import React from "react";
import LearningContentTable from "./components/LearningContentTable";

function Tables() {
  return <LearningContentTable />;
}

export default Tables;
